module.exports = __webpack_public_path__ + "static/TNM095-e3a1f84975aa33651e12fe04aff9c1e6.pdf";